import $ from "jquery";
import "lightgallery";
import "lg-zoom";
import "lg-pager";
// import "lg-thumbnail";
import "lg-share";
import "lg-video";
import "lg-fullscreen";
import "lg-pager";


class LightBox {
	run() {
		this.videoPopup()
		this.lightBox()
	}

	videoPopup() {
		$('#btnPlayVideo').on('click',function() {
			$('#videopopup').addClass('active');
		});

		$('#videoClose').on('click',function() {
			$('#videopopup').removeClass('active');
			$('#videoComplete').get(0).pause();
    		$('#videoComplete').get(0).currentTime = 0;
		});
	}

	lightBox() {
		$('.products-gallery').each(function() {
			var galleryItems = $(this);

			galleryItems.lightGallery({
				selector: '.item img',
				download:false,
				fullScreen: false,
				pager: false,
				zoom: false,
				hash: false,
				loop:false,
				slideEndAnimatoin: false,
				hideControlOnEnd: true,
				showThumbByDefault: false,
				exThumbImage: 'data-src',
				currentPagerPosition: 'middle',
				autoplayControls: true,
				progressBar: true,
				share:false,
				twitter:false,
				googlePlus: false,
				pinterest: false,
			});

			// $(this).on('click', function(e){
			//   $(this).find('.product-gallery .item:first-of-type').click();
			// });
		});
	}
}


const lightBox = new LightBox();
export default lightBox;
